import { isFlagEnabled } from "js/utilities";
import { default as ReleasingForms } from "./Forms";
import DeprecatedForms from "./DeprecatedForms";

export default function Forms() {
  return isFlagEnabled("ENABLE_FORMS_WIZARD") ? (
    <ReleasingForms />
  ) : (
    <DeprecatedForms />
  );
}
